<template>
  <ul class="social-nav">
    <li
      class="social-nav-item"
      v-for="link in socialLinks"
      v-bind:key="link.icon"
    >
      <nav-item :icon="link.icon" :link="link.link" />
    </li>
  </ul>
</template>

<script>
import NavItem from './NavItem'

export default {
  name: 'SocialNav',
  components: {
    'nav-item': NavItem
  },
  data: () => ({
    socialLinks: [
      {
        icon: 'GitHub',
        link: 'https://github.com/wingleung'
      },
      {
        icon: 'LinkedIn',
        link: 'https://www.linkedin.com/in/mrleung/'
      }
    ]
  })
}
</script>

<style lang="scss">
.social-nav {
  position: absolute;
  top: 0.8rem;
  right: 2rem;

  display: flex;

  align-items: flex-start;

  margin: 0;

  list-style: none;

  flex-direction: row;
  justify-content: center;

  z-index: 1;

  animation: fadeIn 1s;
}

.social-nav-item {
  width: 1rem;

  margin: 0.5rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
